import { render, staticRenderFns } from "./bodyprint-edit-view.vue?vue&type=template&id=66858e0c"
import script from "./bodyprint-edit-view.vue?vue&type=script&lang=js"
export * from "./bodyprint-edit-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports